const storeName = 'reviews';

export default {
    INITIALIZE: `${storeName}.INITIALIZE`,
    LOAD_REVIEWS: `${storeName}.LOAD_REVIEWS`,
    LOAD_MORE_REVIEWS: `${storeName}.LOAD_MORE_REVIEWS`,
    SET_REVIEWS: `${storeName}.SET_REVIEWS`,
    SET_MORE_REVIEWS: `${storeName}.SET_MORE_REVIEWS`,
    TRY_INCREMENT_PAGE: `${storeName}.TRY_INCREMENT_PAGE`,
    TRY_DECREMENT_PAGE: `${storeName}.TRY_DECREMENT_PAGE`,
    SET_CURRENT_PAGE: `${storeName}.SET_CURRENT_PAGE`,
    SET_NUMBER_OF_ITEMS_PER_PAGE: `${storeName}.SET_NUMBER_OF_ITEMS_PER_PAGE`,
    SET_LOADING: `${storeName}.SET_LOADING`,
    RESET: `${storeName}.RESET`,
    ADD_ACTIVE_FILTER: `${storeName}.ADD_ACTIVE_FILTER`,
    SET_ACTIVE_FILTER: `${storeName}.SET_ACTIVE_FILTER`,
    REMOVE_ACTIVE_FILTER: `${storeName}.REMOVE_ACTIVE_FILTER`,
    REMOVE_ALL_FILTERS: `${storeName}.REMOVE_ALL_FILTERS`,
    FILTER_REVIEWS: `${storeName}.FILTER_REVIEWS`,
    SET_SORT: `${storeName}.SET_SORT`,
    SET_SORT_DEFAULT: `${storeName}.SET_SORT_DEFAULT`,
    SET_PRODUCT_CODE: `${storeName}.SET_PRODUCT_CODE`,
    OPEN_EXTERNAL_REVIEWS_VENDOR: `${storeName}.OPEN_EXTERNAL_REVIEWS_VENDOR`,
    REPORT_REVIEW: `${storeName}.REPORT_REVIEW`,
    SET_REPORTED_REVIEWS: `${storeName}.SET_REPORTED_REVIEWS`,
    LOAD_REPORTED_REVIEWS: `${storeName}.LOAD_REPORTED_REVIEWS`,
    VOTE_FOR_REVIEW: `${storeName}.VOTE_FOR_REVIEW`,
    GET_PAGE: `${storeName.toUpperCase()}.GET_PAGE`,
    SET_CURRENT_REVIEW: `${storeName}.SET_CURRENT_REVIEW`,
    SET_REACTION: `${storeName}.SET_REACTION`,
    SET_LOADED_REACTIONS: `${storeName}.SET_LOADED_REACTIONS`,
    OPEN_ADD_REVIEW_POPUP: `${storeName}.OPEN_ADD_REVIEW_POPUP`,
    TRANSLATE_REVIEW: `${storeName}.TRANSLATE_REVIEW`,
    SET_SHOW_TRANSLATED_REVIEW: `${storeName}.SET_SHOW_TRANSLATED_REVIEW`,
    SET_TRANSLATION: `${storeName}.SET_TRANSLATION`,
    SET_NEEDS_TRANSLATION: `${storeName}.SET_NEEDS_TRANSLATION`,
    SET_TRANSLATION_LOADING: `${storeName}.SET_TRANSLATION_LOADING`,
    SET_GOOGLE_API_KEY: `${storeName}.SET_GOOGLE_API_KEY`,
    REPORT_ENHANCED_REVIEW: `${storeName}.REPORT_ENHANCED_REVIEW`,
    SHOW_FILTERS_MENU: `${storeName}.SHOW_FILTERS_MENU`,
    HIDE_FILTERS_MENU: `${storeName}.HIDE_FILTERS_MENU`,
    INCREASE_LOAD_ITERATION: `${storeName}.INCREASE_LOAD_ITERATION`,
    OPEN_LOGIN: `${storeName}.OPEN_LOGIN`,
    RESET_CURRENT: `${storeName}.RESET_CURRENT`,
};
